module.exports = __webpack_public_path__ + "static/img/company-search-logo.1baecd82.png";